(function () {
  if (window.__termsPageScriptLoaded) return;
  window.__termsPageScriptLoaded = true;

  var observer;

  function createObserver() {
    if (observer || !("IntersectionObserver" in window)) return;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.14,
        rootMargin: "0px 0px -8% 0px"
      }
    );
  }

  function initAnimations(root) {
    root = root || document;
    createObserver();

    var items = root.querySelectorAll("[data-terms-animate]");
    items.forEach(function (item) {
      if (item.dataset.termsBound === "true") return;
      item.dataset.termsBound = "true";

      if (observer) {
        observer.observe(item);
      } else {
        item.classList.add("is-visible");
      }
    });
  }

  function init(root) {
    initAnimations(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();